import { CreateNS } from '../lib/createAPIBuilder';

export const installAPIMonitoring = (namespace: CreateNS) => {
    namespace('monitoring')(({ func, prop, deps }) => {
        func('triggerFsEvent', deps.triggerFsEvent);
        func('updateBrazeUserProfile', deps.updateBrazeUserProfile);
    });
};
